require('prismjs/components/prism-c.min');
require('prismjs/components/prism-cpp.min');
require('prismjs/components/prism-csharp.min');
require('prismjs/components/prism-java.min');
require('prismjs/components/prism-python.min');
require('prismjs/components/prism-sql.min');
require('prismjs/components/prism-swift.min');
require('prismjs/components/prism-json.min');
require('prismjs/themes/prism.css');
require('prismjs/plugins/toolbar/prism-toolbar.css');
require('prismjs/plugins/line-numbers/prism-line-numbers.css');
require('prismjs/plugins/toolbar/prism-toolbar.min');
require('prismjs/plugins/show-language/prism-show-language.min');
require('prismjs/plugins/line-numbers/prism-line-numbers.min');